// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JZ2k","index":"styles_index__3Zg96"};